export default __webpack_public_path__ + "static/media/complex-community-1.8b338318.png";